import { YAK_TRAILS_CLIENT_TUNING } from "../tuning";

export function getShowcaseCameraZoom(canvasHeight: number): number {
  const tuning = YAK_TRAILS_CLIENT_TUNING.showcase;
  return Math.min(tuning.maximumZoom, Math.max(0, canvasHeight) / tuning.minimumVerticalWorldSpan);
}

export function getShowcaseModelScale(skinId: string): number {
  const tuning = YAK_TRAILS_CLIENT_TUNING.showcase;
  return tuning.modelScale * (tuning.modelScaleBySkin[skinId] ?? 1);
}
